import { jsx as _jsx } from "react/jsx-runtime";
import MaxRecordsCustomSectionCore from '../../../maxRecords/MaxRecordsCustomSectionCore';
const MaxRecordsButton = () => {
    return _jsx(MaxRecordsCustomSectionCore, {});
};
export default MaxRecordsButton;
//# sourceMappingURL=MaxRecordsButton.js.map